import React from 'react';
import { fpqUrl } from '../../utils/variables';

export default function LandingPageCta({ url = fpqUrl, copy, children, classes = '' }) {
	const handleRedirect = () => {
		const urlParams = document.location.search;

		window.location.href = url + urlParams;
	};

	return (
		<button onClick={handleRedirect} className={`c-cta ${classes}`}>
			{children || copy}
		</button>
	);
}
